














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { CreditCardAssignment, CreditCardType } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";

@Component({
  name: "CardItem",
})
export default class CardItem extends Vue {
  @Prop({ required: true })
  public readonly card!: CreditCardAssignment;

  get image() {
    return this.card.type !== CreditCardType.OTHER ? this.card.type : "";
  }
}
